export default "__VITE_ASSET__cyGlnDhr__"